const header = document.querySelector('#header');
const toggleBtn = document.querySelector('#toggle');
const search = document.querySelector('#search');
const searchToggle = document.querySelector('#searchToggle');
// const telIco = document.querySelector('#telIco');
// const mailIco = document.querySelector('#mailIco');
// const mobileNav = document.querySelector('#mobileNav');
const accHeader = document.querySelectorAll('.cmn__accHeader');


toggleBtn.addEventListener('click', () => {
    header.classList.toggle('is-open');
});

searchToggle.addEventListener('click', () => {
    search.classList.toggle('is-open');
});

accHeader.forEach(accHeaderIndex => {
    accHeaderIndex.addEventListener('click', () => {
        const accHeaderIndexPare = accHeaderIndex.parentNode;
        accHeaderIndexPare.classList.toggle('open');
    });
});
